import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Button,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { useHistory } from "react-router-dom";
import { getApi } from "../../services/api";
import { PROJECT_MIS } from "../../configs/urls";
import Loader from "../../components/Loader";
import WiseDialog from "./WiseDialog";
import { useAtom } from "jotai";
import { projectIdStore } from "store/store";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  marginLeft: {
    marginLeft: 10,
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

export default function ProjectMis(props) {
  const classes = useStyles();
  const history = useHistory();

  const [projects, setProjects] = useState([]);
  const [isRequesting, setIsRequesting] = useState(false);
  const [open, setOpen] = useState(false);
  const [projectId, setProjectId] = useAtom(projectIdStore);

  const [dialogData, setDialogData] = useState({
    projectName: "",
    projectId: "",
  });

  useEffect(() => {
    setIsRequesting(true);
    getApi(PROJECT_MIS)
      .then((res) => {
        setProjects(res.data);
      })
      .catch((err) => {})
      .finally(() => {
        setIsRequesting(false);
      });
  }, []); //eslint-disable-line

  const handleClose = () => {
    setOpen(false);
  };

  const viewProjectDetail = (project) => {
    history.push("/admin/project/view/" + project.id);
  };

  const renderProject = () => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Total Farmer</TableCell>
            <TableCell>Total Complete Job</TableCell>
            <TableCell>Total Area covered</TableCell>
            <TableCell>District</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projects.map((project, idx) => (
            <TableRow key={idx}>
              <TableCell>{project.name || "--"}</TableCell>
              <TableCell>{project.farmers.length || "--"}</TableCell>
              <TableCell>{project.total_completed_jobs || "--"}</TableCell>
              <TableCell>{project.total_area_covered || "--"}</TableCell>
              <TableCell>
                {project.district ? project.district.name : "--"}
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  type="button"
                  color="primary"
                  onClick={() => {
                    setOpen(true);
                    setDialogData({
                      projectName: project.name,
                    });
                    setProjectId(project.id);
                  }}
                >
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <>
      <div className={classes.root}>
        <Loader isLoading={isRequesting} />
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {projects.length ? (
              renderProject()
            ) : (
              <Box
                fontSize="h6.fontSize"
                m={1}
                p={{ xs: 2, sm: 2, md: 2 }}
                style={{ textAlign: "center" }}
              >
                No Project Found
              </Box>
            )}
          </GridItem>
        </GridContainer>
      </div>
      <WiseDialog open={open} onClose={handleClose} dialogData={dialogData} />
    </>
  );
}
